(function () {
  'use strict';

  var CACHE_TTL = 10 * 60 * 1000;
  var MAX_CORRECTIONS = 10;
  var CHECKOUT_TIMEOUT = 1500;
  var CHECKOUT_SELECTORS = [
    '.rebuy-cart__checkout-button',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ];
  var PREORDER_PROPERTY = 'Pre-order';
  var SHIP_BY_PROPERTY = '_preorder_ship_by';
  var productsNode = document.getElementById('nsk-preorder-products');
  var configNode = document.getElementById('nsk-preorder-cart-config');
  var activeProductIds = parseJson(productsNode, []);
  var config = parseJson(configNode, {});
  var activeProducts = {};
  var memoryCache = {};
  var debounceTimer = null;
  var syncing = false;
  var pendingRun = false;
  var activeRun = null;
  var drawerOpenFromEvents = false;
  var checkoutPending = false;
  var checkoutBypass = false;
  var latestCartHint = null;
  var suppressEventsUntil = 0;

  if (!Array.isArray(activeProductIds) || !config.store || activeProductIds.length === 0) return;

  activeProductIds.forEach(function (productId) {
    activeProducts[String(productId)] = true;
  });

  function parseJson(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function cartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : null;
  }

  function rebuyCartSnapshot() {
    if (!window.Rebuy || !window.Rebuy.Cart) return null;
    return cartItems(window.Rebuy.Cart.cart) ? window.Rebuy.Cart.cart : null;
  }

  function eventCart(event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && cartItems(cart.cart)) return cart.cart;
    return cartItems(cart) ? cart : null;
  }

  function hasListedProduct(cart) {
    var items = cartItems(cart);
    if (!items) return false;

    return items.some(function (item) {
      return activeProducts[String(item.product_id)];
    });
  }

  function myDrawerOpen() {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart && typeof smartCart.visible === 'boolean') return smartCart.visible;
    return drawerOpenFromEvents;
  }

  // MY: any /cart/change.js makes Rebuy open the Smart Cart, so background corrections only run while it is already open.
  function backgroundSyncAllowed() {
    return config.store !== 'MY' || myDrawerOpen();
  }

  function scheduleSync(cartHint) {
    if (Date.now() < suppressEventsUntil) return;
    if (cartItems(cartHint)) latestCartHint = cartHint;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var hint = latestCartHint;
      latestCartHint = null;

      if (!backgroundSyncAllowed()) return;

      if (!hint && config.store === 'MY') hint = rebuyCartSnapshot();
      if (hint && !hasListedProduct(hint)) return;
      if (!hint && config.store === 'MY') return;

      runSync();
    }, 300);
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options);
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  }

  function readCachedProduct(handle) {
    var cacheKey = 'nsk-preorder-cart:' + handle;
    var cached = memoryCache[cacheKey];

    if (!cached) {
      try {
        cached = JSON.parse(sessionStorage.getItem(cacheKey));
      } catch (error) {
        cached = null;
      }
    }

    if (!cached || !cached.savedAt || Date.now() - cached.savedAt >= CACHE_TTL) return null;
    memoryCache[cacheKey] = cached;
    return cached.data;
  }

  function cacheProduct(handle, data) {
    var cacheKey = 'nsk-preorder-cart:' + handle;
    var cached = { savedAt: Date.now(), data: data };
    memoryCache[cacheKey] = cached;

    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(cached));
    } catch (error) {
      return;
    }
  }

  async function productData(handle) {
    var cached = readCachedProduct(handle);
    if (cached) return cached;

    var data = await fetchJson('/products/' + encodeURIComponent(handle) + '?view=preorder-json');
    cacheProduct(handle, data);
    return data;
  }

  // Shopify keeps a blanked property as "", so blank and missing mean the same thing here.
  function present(value) {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  function labelForDate(date) {
    var parsed = new Date(date + 'T00:00:00Z');
    if (isNaN(parsed.getTime())) return '';

    return 'Ships by ' + new Intl.DateTimeFormat('en', {
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    }).format(parsed);
  }

  // Total quantity of each variant across all its cart lines.
  function variantTotals(cart) {
    var totals = {};
    (cartItems(cart) || []).forEach(function (line) {
      var id = String(line.variant_id);
      totals[id] = (totals[id] || 0) + (parseInt(line.quantity, 10) || 0);
    });
    return totals;
  }

  // Preorder variants always carry the properties. An in-stock continue-policy variant does too once the
  // cart holds more of it than is in stock (a split order); every line of that variant is flagged, the
  // same way the PDP stamps the whole line.
  function needsPreorderProperties(product, variant, variantTotal) {
    if (variant.state === 'preorder') return true;
    if (variant.state !== 'in_stock' || variant.policy !== 'continue' || !product.eligible) return false;
    var availableNow = Math.max(parseInt(variant.available_now, 10) || 0, 0);
    return variantTotal > availableNow;
  }

  function correctedProperties(line, productsByHandle, totals) {
    var product = productsByHandle[line.handle];
    var variant = product && product.variants && product.variants[String(line.variant_id)];
    if (!variant) return null;

    var existing = line.properties || {};
    var properties = {};
    var changed = false;

    Object.keys(existing).forEach(function (key) {
      properties[key] = existing[key];
    });

    if (needsPreorderProperties(product, variant, totals[String(line.variant_id)] || 0)) {
      var stampedDate = properties[SHIP_BY_PROPERTY];

      if (!present(stampedDate)) {
        properties[SHIP_BY_PROPERTY] = variant.ship_by;
        properties[PREORDER_PROPERTY] = variant.ship_label;
        changed = true;
      } else if (product.ship_by_custom === true && variant.ship_by > stampedDate) {
        // Only a custom preorder.ship_by that moved later rewrites the promise; the rolling today+28 never does.
        properties[SHIP_BY_PROPERTY] = variant.ship_by;
        properties[PREORDER_PROPERTY] = variant.ship_label;
        changed = true;
      } else if (!present(properties[PREORDER_PROPERTY])) {
        properties[PREORDER_PROPERTY] = labelForDate(stampedDate) || variant.ship_label;
        changed = true;
      }
    } else if (present(properties[PREORDER_PROPERTY]) || present(properties[SHIP_BY_PROPERTY])) {
      delete properties[PREORDER_PROPERTY];
      delete properties[SHIP_BY_PROPERTY];
      if (Object.keys(properties).length === 0) {
        // Shopify ignores properties: {} and keeps the old values, so blank the keys instead.
        properties[PREORDER_PROPERTY] = '';
        properties[SHIP_BY_PROPERTY] = '';
      }
      changed = true;
    }

    return changed ? properties : null;
  }

  function nextCorrection(cart, productsByHandle, attempted) {
    var items = cartItems(cart) || [];
    var totals = variantTotals(cart);

    for (var index = 0; index < items.length; index += 1) {
      var line = items[index];
      if (!activeProducts[String(line.product_id)]) continue;
      // One attempt per line per run: a line Shopify did not change is left for the next trigger.
      if (attempted[line.key] || attempted['#' + index]) continue;

      var properties = correctedProperties(line, productsByHandle, totals);
      if (properties) return { line: line, index: index, properties: properties };
    }

    return null;
  }

  async function loadProducts(cart) {
    var handles = [];

    (cartItems(cart) || []).forEach(function (line) {
      if (!activeProducts[String(line.product_id)]) return;
      if (handles.indexOf(line.handle) === -1) handles.push(line.handle);
    });

    var productsByHandle = {};
    for (var index = 0; index < handles.length; index += 1) {
      productsByHandle[handles[index]] = await productData(handles[index]);
    }
    return productsByHandle;
  }

  function refreshMySmartCartSilently() {
    if (!window.Rebuy || !window.Rebuy.Cart || typeof window.Rebuy.Cart.fetchShopifyCart !== 'function') return;

    // VERIFY-LIVE: Rebuy documents fetchShopifyCart, but not whether it always re-renders the visible Smart Cart without opening it.
    window.Rebuy.Cart.fetchShopifyCart(function () {});
  }

  function refreshCartUi(cart) {
    suppressEventsUntil = Date.now() + 1000;

    if (config.store === 'MY') {
      refreshMySmartCartSilently();
      return;
    }

    // SG native drawer listens on documentElement (theme rootDelegate), so an event on document never reaches it.
    // No openMiniCart: the drawer re-renders in place without opening.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  }

  async function syncCart(options) {
    var cart = await fetchJson('/cart.js');
    if (!hasListedProduct(cart)) return;

    var productsByHandle = await loadProducts(cart);
    var attempted = {};
    var corrections = 0;
    var correction = nextCorrection(cart, productsByHandle, attempted);

    while (correction && corrections < MAX_CORRECTIONS) {
      // The drawer may have closed while product data loaded; a change now would reopen it.
      if (!options.checkout && !backgroundSyncAllowed()) break;

      attempted[correction.line.key] = true;
      attempted['#' + correction.index] = true;
      suppressEventsUntil = Date.now() + 1000;
      cart = await fetchJson('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: correction.line.key,
          quantity: correction.line.quantity,
          properties: correction.properties
        })
      });
      corrections += 1;
      // Compare against the cart Shopify returned, never against what was sent.
      correction = nextCorrection(cart, productsByHandle, attempted);
    }

    // At checkout the page is about to leave, so no cart UI refresh.
    if (corrections > 0 && !options.checkout) refreshCartUi(cart);
  }

  function runSync(options) {
    if (syncing) {
      pendingRun = true;
      return activeRun;
    }

    syncing = true;
    activeRun = syncCart(options || {}).catch(function () {
      return null;
    }).then(function () {
      syncing = false;
      activeRun = null;

      if (pendingRun) {
        pendingRun = false;
        scheduleSync();
      }
    });
    return activeRun;
  }

  function syncBeforeCheckout() {
    if (config.store === 'MY') {
      var snapshot = rebuyCartSnapshot();
      if (snapshot && !hasListedProduct(snapshot)) return Promise.resolve();
    }

    clearTimeout(debounceTimer);
    var work = (activeRun || Promise.resolve()).then(function () {
      return runSync({ checkout: true });
    });
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, CHECKOUT_TIMEOUT);
    });
    // Checkout is never blocked for longer than CHECKOUT_TIMEOUT.
    return Promise.race([work, timeout]);
  }

  function checkoutSelectorFor(element) {
    for (var index = 0; index < CHECKOUT_SELECTORS.length; index += 1) {
      if (element.matches(CHECKOUT_SELECTORS[index])) return CHECKOUT_SELECTORS[index];
    }
    return null;
  }

  function continueCheckout(target, selector) {
    var next = target.isConnected ? target : document.querySelector(selector);
    if (!next) {
      window.location.assign('/checkout');
      return;
    }

    checkoutBypass = true;
    try {
      next.click();
    } finally {
      checkoutBypass = false;
    }
  }

  document.addEventListener('click', function (event) {
    if (checkoutBypass) return;

    var target = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTORS.join(',')) : null;
    if (!target || target.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;

    var selector = checkoutSelectorFor(target);
    checkoutPending = true;
    syncBeforeCheckout().then(function () {
      checkoutPending = false;
      continueCheckout(target, selector);
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync();
  });
  document.addEventListener('cart:updated', function (event) {
    scheduleSync(eventCart(event));
  });
  document.addEventListener('cart:refresh', function (event) {
    scheduleSync(eventCart(event));
  });

  if (config.store === 'MY') {
    document.addEventListener('rebuy:smartcart.show', function (event) {
      drawerOpenFromEvents = true;
      scheduleSync(eventCart(event) || rebuyCartSnapshot());
    });
    document.addEventListener('rebuy:smartcart.hide', function () {
      drawerOpenFromEvents = false;
    });
    document.addEventListener('rebuy:cart.ready', function (event) {
      scheduleSync(eventCart(event));
    });
    document.addEventListener('rebuy:cart.change', function (event) {
      scheduleSync(eventCart(event));
    });
    document.addEventListener('rebuy:smartcart.line-item-increase', function () {
      scheduleSync(rebuyCartSnapshot());
    });
    document.addEventListener('rebuy:smartcart.line-item-decrease', function () {
      scheduleSync(rebuyCartSnapshot());
    });
    document.addEventListener('rebuy:smartcart.line-item-removed', function () {
      scheduleSync(rebuyCartSnapshot());
    });
  }
})();
